import { create } from "zustand";
import { devtools } from "zustand/middleware";
import createSelectors from "./selectors";

interface ObjectEditState {
  objectEdit: object;
  setObjectEdit: (objectEdit: object) => void;

  textAlign: string;
  setTextAlign: (textAlign: string) => void;

  fontFamily: string;
  setFontFamily: (textAlign: string) => void;

  fontSize: string;
  setFontSize: (fontSize: string) => void;

  fontColor: string;
  setFontColor: (fontColor: string) => void;

  fontLine: string;
  setFontLine: (fontLine: string) => void;

  isOpenLineSelect: boolean;
  setIsOpenLineSelect: (isOpenLineSelect: boolean) => void;
}

const useObjectEditStore = create<ObjectEditState>()(
  devtools(
    (set) => ({
      objectEdit: {},
      textAlign: 'left',
      fontSize: '',
      fontColor: '#1F1F1FFF',
      fontFamily: '',
      fontLine: '1',
      isOpenLineSelect: false,

      setObjectEdit: (objectEdit: object) =>
        set({ objectEdit }),

      setTextAlign: (textAlign: string) =>
        set({ textAlign }),

      setFontSize: (fontSize: string) =>
        set({ fontSize }),

      setFontColor: (fontColor: string) =>
        set({ fontColor }),

      setFontFamily: (fontFamily: string) =>
        set({ fontFamily }),

      setFontLine: (fontLine: string) =>
        set({ fontLine }),

      setIsOpenLineSelect: (isOpenLineSelect: boolean) =>
        set({ isOpenLineSelect }),
    }),
    { name: "object-edit-store" }
  )
);

export default createSelectors(useObjectEditStore);
